<template>
  <div class="contact">
    <div data-aos="zoom-in-up" class="social-icons-container">
      <h3>
        Look for me in
      </h3>
      <a href="https://github.com/sevillecarlos" target="_blank">
        <b-icon class="social-icon" icon="github" aria-hidden="true"></b-icon>
      </a>
      <a href="https://twitter.com/sevillecarlos" target="_blank">
        <b-icon class="social-icon" icon="twitter" aria-hidden="true"></b-icon>
      </a>
      <a
        href="https://www.linkedin.com/in/carlos-alberto-sevilla/"
        target="_blank"
      >
        <b-icon class="social-icon" icon="linkedin" aria-hidden="true"></b-icon>
      </a>

      <h2 class="email-msg">
        Send me an email <br /><span
          id="email-text"
          class="email"
          :v-model="email"
          v-clipboard:copy="email"
          >{{ email }}</span
        >
      </h2>
      <b-popover
        target="email-text"
        triggers="hover"
        placement="right"
        content="content-popover-email"
        custom-class="popover-email"
      >
        <span class="text-popover-email">
          <b>Click</b> on the email to copy it
        </span>
      </b-popover>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "sevillecarlos@gmail.com",
    };
  },
};
</script>

<style>
.contact {
  padding: 50px;
  text-align: center;
}
.social-icons-container * {
  margin-left: 3%;
}
.social-icons-container h3 {
  color: #ffbb00 !important;
  font-weight: bold;
  padding: 5px;
  font-size: 3vw;
  text-shadow: 3px 3px #000000;
}
.social-icons-container a {
  color: #a8a9ad !important;
  font-size: 5vw !important;
  transition: 0.3s color;
}
.social-icons-container a:hover {
  color: #ffbb00 !important;
}

.email-msg {
  color: #ffbb00 !important;
  font-weight: bold;
  padding: 5px;
  font-size: 4vw;
  text-shadow: 3px 3px #000000;
}
.email {
  color: #a8a9ad !important;
  cursor: pointer;
}
.popover-email {
  background: rgb(23, 23, 24) !important;
  border-radius: 50px !important;
  border: 1px solid black;
  padding: 1px !important;
  box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.89);
  -webkit-box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.89);
  -moz-box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.89);
}
.text-popover-email {
  color: #a8a9ad !important;
  font-size: 0.8vw;
}
.text-popover-email b {
  color: #ffbb00 !important;
}

/*****************************************************/
@media only screen and (max-width: 1032px) {
  .social-icons-container h3 {
    font-size: 5vw;
  }
  .social-icons-container a {
    font-size: 11vw !important;
  }
  .social-icons-container a:hover {
    color: #ffbb00 !important;
  }
  .email-msg {
    font-size: 5vw;
  }

  .text-popover-email {
    color: #a8a9ad !important;
    font-size: 1.4vw;
  }
}

/* Small phones to small tablets: from 481 to 767*/
@media only screen and (max-width: 767px) {
  .social-icons-container h3 {
    font-size: 6vw;
  }
  .social-icons-container a {
    font-size: 13vw !important;
  }
  .social-icons-container a:hover {
    color: #ffbb00 !important;
  }
  .email-msg {
    font-size: 5.5vw;
  }

  .text-popover-email {
    color: #a8a9ad !important;
    font-size: 3vw;
  }
}

/*Small Phone from 0 to 480px*/
@media only screen and (max-width: 400px) {
  .social-icons-container h3 {
    font-size: 6vw;
  }
  .social-icons-container a {
    font-size: 13vw !important;
  }
  .social-icons-container a:hover {
    color: #ffbb00 !important;
  }
  .email-msg {
    font-size: 5.5vw;
  }

  .text-popover-email {
    color: #a8a9ad !important;
    font-size: 3vw;
  }
}
</style>
